import { ILegacyRecords } from 'src/app/common/models/ILegacyRecords';

export class SetLegacyRecordsData {
  static readonly type = '[ILegacyRecords] Set RecordsOf Data';

  constructor(public data: ILegacyRecords) {}
}

export class ClearLegacyRecords {
  static readonly type = '[ILegacyRecords] Clear RecordsOf State';

  constructor() {}
}
